import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

export interface HelpIconProps {
  className?: string;
  onClick?: (e: ElementMouseEvent) => void;
}

const HelpIcon: React.FunctionComponent<HelpIconProps> = (props: HelpIconProps): JSX.Element => (
  <span
    aria-label="Help"
    className={classNames('helpIcon-container', props.className)}
    role="button"
    tabIndex={0}
  >
    <BenchlingIcon {...props} className="helpIcon" icon="question" />
  </span>
);

export default HelpIcon;
